
export const asBool = val =>
	typeof val === "string"
		? isNaN(val)
			? ["yes", "sí", "si", "true", "verdadero", "on"].some(a => a.startsWith(val.toLowerCase()))
			: !!(val * 1)
		: !!val

